module.exports = __webpack_public_path__ + "static/media/blue-loader.e62a99c3.svg";